import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import { useContext } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
//import { HashRouter, Routes, Route } from 'react-router-dom';
import LeftMenu from './Components/LeftMenu';
import PageHome from './Pages/PageHome';
import PagePedidos from './Pages/PagePedidos';
import PageFinanceiro from './Pages/PageFinanceiro';
import PagePerfil from './Pages/PagePerfil';
import PageSignup from './Pages/PageSignup';
import { GetUserContext } from './Context/GetUserContext';

function App() {
  const { pageIsLogin } = useContext(GetUserContext);

  return (
    <BrowserRouter>
      <div className="App">
        {pageIsLogin ? (<></>) : (<LeftMenu />)}
        <Routes>
          <Route path="/" element={<PageSignup />} />
          <Route path="/home" element={<PageHome />} />
          <Route path="/pedidos" element={<PagePedidos />} />
          <Route path="/financeiro" element={<PageFinanceiro />} />
          <Route path="/perfil" element={<PagePerfil />} />
        </Routes>
        
      </div>
    </BrowserRouter>
  );
}

export default App;
